// extracted by mini-css-extract-plugin
export var gif = "_iz-0";